import React from 'react';
import '../index.css';

const VerticalTimeline = ({ milestones }) => {
    return (
        <div className="timeline-container">
            <div className="timeline-line"></div>
            {milestones.map((milestone, index) => (
                <div className="timeline-item" key={index}>
                    <div className="timeline-date">
                        {milestone.formattedDate}
                    </div>
                    <div className="timeline-content">
                        {Array.isArray(milestone.label) ? (
                            milestone.label.map((line, idx) => (
                                <p style={{marginBottom: 10}} key={idx}>{line}</p>
                            ))
                        ) : (
                            <p>{milestone.label}</p>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default VerticalTimeline;
